
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { ShiftAutomationInterface } from '@/services/Calendar/ShiftAutomation/Interfaces';
import { EditShiftAutomationForm } from '@/services/Calendar/ShiftAutomation/forms/EditShiftAutomationForm';
import ShiftAutomationRepository from '@/services/Calendar/ShiftAutomation';
import { ShiftTypeInterface } from '@/services/Calendar/ShiftType/Interfaces';
import ShiftTypeRepository from '@/services/Calendar/ShiftType';
import UsersRepo from "@/services/Users";
import { UserInterface } from "@/services/Users/Interfaces";
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: {
    PageHeader,
  },
  inject: [
    'shiftAutomationRepository',
    'shiftTypeRepository',
    'userRepository',
  ],
})
export default class EditShiftType extends Vue {
  private readonly shiftAutomationRepository!: ShiftAutomationRepository;
  private readonly shiftTypeRepository!: ShiftTypeRepository;
  private readonly userRepository!: UsersRepo;

  private loading: boolean = true;

  private shiftAutomation: Partial<ShiftAutomationInterface> = {};
  private shiftType: ShiftTypeInterface[] = [];
  private users: UserInterface[] = [];
  private form: WPXFormValue<EditShiftAutomationForm> = new WPXFormValue(EditShiftAutomationForm);

  private async created(): Promise<void> {
    if (!this.$route.params.id) {
      await this.$router.push({ name: 'calendar_manage_shifts' });
      this.$notifications.error('Shift Automation ID not provided.');

      return;
    }

    try {
      const users = await this.userRepository.getAllUsers();
      const shiftType = await this.shiftTypeRepository.getAllShiftTypes();
      this.users = users[0];
      this.shiftType = shiftType.filter((shiftType) => shiftType.automations);
      this.shiftAutomation = await this.shiftAutomationRepository.getShiftAutomationsById(Number(this.$route.params.id));
      this.form.data.userId = String(this.shiftAutomation.userId);
      this.form.data.shiftType = Number(this.shiftAutomation.shiftType?.id);
    } catch (e) {
      console.error(e);
    }

    this.loading = false;
  }

  private async edit(): Promise<void> {
    try {
      await this.shiftAutomationRepository.updateShiftAutomation({
          id: Number(this.$route.params.id),
          userId: this.form.data.userId,
          shiftType: this.form.data.shiftType,
        },
      );

      this.$successDialog.show(`Shift Automation has been edited.`);
    } catch (err) {
      this.$errorDialog.show(err.response.data.error);
    }
  }
}
